export const BRAND_AWARE_PATHS = new Set([
  "/dashboard",
  "/disputes",
  "/alerts/order-insight",
  "/alerts/ethoca",
  "/alerts/cdrn",
  "/alerts/rdr-notices",
  "/alerts/fraud-notices",
  "/alerts/dispute-notices",
  "/alerts/ce-notices",
  "/alerts/enrolments",
  "/reports",
]);

export function isBrandAwarePath(pathname: string): boolean {
  return BRAND_AWARE_PATHS.has(pathname) || pathname === "/inquiries" || pathname.startsWith("/inquiries/");
}
